import { useStoryblokBridge } from '@storyblok/react';
import type { ISbStoryData } from '@storyblok/react';
import { useState, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { CardPageBackLink } from '../components/CardPageBackLink.js';
import { CmsContent } from '../components/CmsContent.js';
import { CmsStoryProvider } from '../contexts/CmsStoryContext.js';
import { useStory } from '../hooks/useStory.js';

// Bridge wrapper: keeps the story live once we have an ID.
const StoryWithBridge = ({ story }: { story: ISbStoryData }) => {
  const [liveStory, setLiveStory] = useState(story);

  useStoryblokBridge(story.id, (updated) => {
    setLiveStory(updated);
  });

  return <CmsContent story={liveStory} />;
};

export const StoryLayout = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const slug = location.pathname === '/' ? 'home' : location.pathname.slice(1);
  const state = useStory(slug);

  return (
    <CmsStoryProvider story={state}>
      {state.status === 'found' && (
        <>
          <CardPageBackLink />
          <StoryWithBridge key={state.story.id} story={state.story} />
        </>
      )}
      {children}
    </CmsStoryProvider>
  );
};
